<template>
  <div class="component-one">
    <p>Component One (should be green)</p>
  </div>
</template>

<script>
export default {
  name: 'component-one'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// ComponentOne.vue?bade7f54